export const monitoringKeys = {
  all: ['monitoring'] as const,

  campaigns: () => [...monitoringKeys.all, 'campaign'] as const,
  campaign: (campaignId: number) =>
    [...monitoringKeys.campaigns(), campaignId] as const,
  campaignCodes: (campaignId: number) =>
    [...monitoringKeys.campaign(campaignId), 'codes'] as const,
  campaignProposals: (campaignId: number) =>
    [...monitoringKeys.campaign(campaignId), 'proposals'] as const,

  proposals: () => [...monitoringKeys.all, 'proposal'] as const,
  proposal: (proposalId: number) =>
    [...monitoringKeys.proposals(), proposalId] as const,
  proposalCodes: (proposalId: number) =>
    [...monitoringKeys.proposal(proposalId), 'codes'] as const,
};
